var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "div",
        { staticClass: "channel-dis" },
        [
          _c(
            "div",
            { staticClass: "label-item" },
            [
              _c("p", { staticClass: "label-text" }, [
                _vm._v(_vm._s(_vm.field.desc))
              ]),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { effect: "light", placement: "bottom-start" }
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v("\n                - name: "),
                    _c("strong", [_vm._v(_vm._s(_vm.field.name))]),
                    _c("br"),
                    _vm._v(
                      "\n                - 多项条件组合，后面项优先级高于前面项；"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                - 不选渠道和渠道组代表默认项；\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "label-icon el-icon-info" })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.field.def_val || !_vm.field.def_val.length
            ? _c("div", { staticClass: "no-item" }, [
                _vm._v("\n        暂无内容，点击 + 号新增\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.field,
                rules: _vm.fieldRules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "div",
                {
                  ref: "dynamicScroller",
                  staticClass: "infinite-list-wrapper"
                },
                [
                  _c(
                    "div",
                    { staticClass: "infinite-list" },
                    [
                      _c("DynamicScroller", {
                        staticClass: "scroller",
                        attrs: {
                          items: _vm.field.def_val,
                          "min-item-size": 300,
                          "page-mode":
                            _vm.field.def_val.length < 5 ? false : true,
                          "key-field": "scroller_id"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var item = ref.item
                                var index = ref.index
                                var active = ref.active
                                return [
                                  _c(
                                    "DynamicScrollerItem",
                                    {
                                      attrs: {
                                        item: item,
                                        active: active,
                                        "size-dependencies": [item.content],
                                        "data-index": index
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "group-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  "第" + (index + 1) + "项 "
                                                )
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    " 共" +
                                                      _vm.field.def_val.length +
                                                      "项"
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "渠道",
                                                prop: "channels"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "channel-select",
                                                  attrs: {
                                                    placeholder:
                                                      "请选择渠道（多项条件组合，后面项优先级高于前面项；不选渠道和渠道组代表默认项；）",
                                                    multiple: "",
                                                    remote: "",
                                                    "reserve-keyword": "",
                                                    filterable: "",
                                                    "allow-create": "",
                                                    "default-first-option": "",
                                                    "remote-method":
                                                      _vm.remoteChannelsHandler
                                                  },
                                                  model: {
                                                    value: item.channels,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "channels",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.channels"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.channels.slice(0, 100),
                                                  function(item2) {
                                                    return _c("el-option", {
                                                      key: item2.name,
                                                      attrs: {
                                                        label: item2.realname,
                                                        value: item2.name
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "渠道组",
                                                prop: "channel_groups"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "channel-select",
                                                  attrs: {
                                                    placeholder:
                                                      "请选择渠道组（多项条件组合，后面项优先级高于前面项；不选渠道和渠道组代表默认项；）",
                                                    multiple: "",
                                                    filterable: "",
                                                    "reserve-keyword": ""
                                                  },
                                                  model: {
                                                    value: item.channel_groups,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "channel_groups",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.channel_groups"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.channel_groups,
                                                  function(item2) {
                                                    return _c("el-option", {
                                                      key: item2.name,
                                                      attrs: {
                                                        label: _vm.channelGroupLabel(
                                                          item2
                                                        ),
                                                        value: item2.name
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "数据元件",
                                                prop: "editor_base"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "item-input",
                                                  attrs: {
                                                    size: "medium",
                                                    placeholder:
                                                      "请选择数据元件"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.editorBaseChangeHandler(
                                                        $event,
                                                        item,
                                                        index
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: item.editor_base,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "editor_base",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.editor_base"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.editorBases,
                                                  function(item2) {
                                                    return _c("el-option", {
                                                      key: item2.type,
                                                      attrs: {
                                                        label: item2.label,
                                                        value: item2.type
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          item.editor_base
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "受控内容",
                                                    prop: "content"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-edit-block",
                                                      class: [
                                                        item.editor_base ==
                                                        "wangeditor_richtext"
                                                          ? "is-wangeditor"
                                                          : ""
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        item.editor_base.replace(
                                                          /\_/g,
                                                          "-"
                                                        ),
                                                        {
                                                          key: "field_" + index,
                                                          ref: "field_" + index,
                                                          tag: "component",
                                                          attrs: {
                                                            field: {
                                                              def_val:
                                                                item.content
                                                            },
                                                            autoInit: true
                                                          },
                                                          on: {
                                                            "val-change": function(
                                                              $event
                                                            ) {
                                                              return _vm.valChangeHandler(
                                                                index,
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("el-button", {
                                            staticClass: "remove-btn",
                                            attrs: {
                                              icon: "el-icon-delete",
                                              title: "删除该项"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.remove(index)
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          index === _vm.field.def_val.length - 1
                                            ? _c(
                                                "div",
                                                { staticClass: "no-more" },
                                                [
                                                  _vm._v(
                                                    "\n                                    没有更多数据，到底了\n                                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          828077433
                        )
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { staticClass: "add-btn", on: { click: _vm.add } },
                    [_vm._v("+")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b777f5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b777f5d","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/channelDis.vue
// module id = 1228
// module chunks = 7